import { render, staticRenderFns } from "./resource-shixun-edit.vue?vue&type=template&id=6f5a4280&scoped=true&"
import script from "./resource-shixun-edit.vue?vue&type=script&lang=ts&"
export * from "./resource-shixun-edit.vue?vue&type=script&lang=ts&"
import style0 from "./resource-shixun-edit.vue?vue&type=style&index=0&id=6f5a4280&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5a4280",
  null
  
)

export default component.exports